import { useState } from "react";
import ProcessLayout from "../../Components/ProcessLayout";
import AccountValidation from "../../Components/UpgradeAccountDialog/AccountValidation";
import MeansOfId from "../../Components/UpgradeAccountDialog/MeansOfId";
import SuccessPage from "../../Components/UpgradeAccountDialog/successPage";
import Summary from "../../Components/UpgradeAccountDialog/Summary";
import { useSearchParams } from "react-router-dom";
import CustomerDetails from "../../Components/UpgradeAccountDialog/CustomerDetails";

const UpgradeAccount = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [searchParams] = useSearchParams();
  const isTier3 = searchParams.get("type") === "tier3";

  return (
    <ProcessLayout
      stepperProps={{
        steps: [
          "Account Validaton",
          isTier3 ? "Proof of Address" : "Employment Details",
          "Means of ID",
          "Summary",
        ],
        label: "Upgrade Account",
        currentStepIndex: currentStep,
      }}
    >
      {currentStep === 0 && (
        <AccountValidation setCurrentStep={setCurrentStep} />
      )}
      {currentStep === 1 && <CustomerDetails setCurrentStep={setCurrentStep} />}
      {currentStep === 2 && <MeansOfId setCurrentStep={setCurrentStep} />}
      {currentStep === 3 && <Summary setCurrentStep={setCurrentStep} />}
      {currentStep === 4 && <SuccessPage setCurrentStep={setCurrentStep} />}
    </ProcessLayout>
  );
};

export default UpgradeAccount;
